import { render, staticRenderFns } from "./assetsManage.vue?vue&type=template&id=1cde4bcb&"
import script from "./assetsManage.vue?vue&type=script&lang=js&"
export * from "./assetsManage.vue?vue&type=script&lang=js&"
import style0 from "./assetsManage.vue?vue&type=style&index=0&id=1cde4bcb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports